
const reducer = (state, action) => {
    switch (action.type) {
        case "setUpcomingEvent":
            return {
                ...state,
                upcomingEvent: action.payload.events
            }

        case "setPastEvent":
            return {
                ...state,
                pastEvent: action.payload.events
            }

        case "setAllEvents":
            return {
                ...state,
                allEvents: action.payload.events
            }

        case "setAllBattle":
            return {
                ...state,
                allBattle: action.payload.event
            }

        case "setAllInterestedEvent":
            return {
                ...state,
                allInterestedEvent: action.payload.data
            }

        case "setUserDetails":
            return {
                ...state,
                userDetails: action.payload.data
            }

        case "setCountry":
            return {
                ...state,
                country: action.payload.data
            }

        case "setCity":
            return {
                ...state,
                city: action.payload.data
            }

        case "setArtType":
            return {
                ...state,
                artType: action.payload.data
            }

        case "setArtwork":
            return {
                ...state,
                artwork: action.payload.data
            }

        case "setParticipate":
            return {
                ...state,
                participate: action.payload.data
            }

        case "setCommunicate":
            return {
                ...state,
                communicate: action.payload.data
            }

        case "setMediaType":
            return {
                ...state,
                mediaType: action.payload.data
            }

        case "setTagCategoryKeyword":
            return {
                ...state,
                tagCategoryKeyword: action.payload.data
            }

        case "setAllUserPosts":
            return {
                ...state,
                allUserPosts: action.payload.data
            }

        case "setSingleUserPost":
            return {
                ...state,
                singleUserPost: action.payload.data
            }

        case "setPastCitiesWithBattles":
            return {
                ...state,
                pastCitiesWithBattles: action.payload.data
            }

        case "setCityEventDetails":
            return {
                ...state,
                cityEventDetails: action.payload.data
            }
          
            
    
        default:
            return state;
    }
    
}

export default reducer